const assignFormValues: (object: any, formValue: any) => void = (object: any, formValue: any) => {
    for (let prop in formValue) {
        if (object.hasOwnProperty(prop)) {
            object[prop] = formValue[prop];
        }
    }
};

export default assignFormValues;
